<template>
    <v-container>
        <v-layout row wrap>
            <v-flex xs12 s12 md12>
                <v-treeview
                        v-if="documents.length > 0"
                        :items="documents"
                        open-all
                        v-model="tree"
                        activatable
                        return-object
                >
                    <template slot="prepend" slot-scope="{ item, open, leaf }">
                        <v-icon v-if="!item.file">
                            {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                        </v-icon>
                        <v-icon v-else @contextmenu="showFile($event, item.id, item.document)">
                            {{ files[item.file] }}
                        </v-icon>
                    </template>
                    <template slot="label" slot-scope="{ item, open, leaf }">
                        {{ item.name }}
                        <v-btn v-if="item.file" flat :href="BASE + 'sample-order/' + order_id + '/pdf/' + item.document.id + '?token=' + item.document.token + '&download_token=' + download_token" target="_blank"><v-icon>mdi-cloud-download</v-icon></v-btn>
                    </template>
                </v-treeview>
                <v-menu
                        v-model="showMenuFile"
                        :position-x="x"
                        :position-y="y"
                        absolute
                        offset-y
                >
                    <v-list>
                        <v-list-tile
                        >
                            <v-btn v-if="showMenuFile" flat block :href="BASE + 'sample-order/' + order_id + '/pdf/' + document.id + '?token=' + document.token + '&download_token=' + download_token" target="_blank"><v-icon left>mdi-cloud-download</v-icon>Download</v-btn>

                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-flex>
        </v-layout>
        <v-snackbar
                v-model="snackbar"
                multi-line=""
                top
                vertical=""
        >
            {{ text }}
            <v-btn
                    color="pink"
                    flat
                    @click="snackbar = false"
            >
                Close
            </v-btn>
        </v-snackbar>

    </v-container>
</template>

<script>
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'

    import { API_BASE } from  '../../../../config';
    import { BASE } from '../../../../config';

    export default {
        props: ['order_id', 'sample'],
        data: function () {
            return {
                dropzoneOptions: {
                    url: '',
                    thumbnailWidth: 150,
                    maxFilesize: 500,
                    headers: { 'Authorization' : localStorage.getItem('token'),
                        'Autrollization' : localStorage.getItem('token'),
                        'Authorization-temp' : localStorage.getItem('token')
                    },
                    addRemoveLinks: true,
                },
                documents: [],
                API_BASE: API_BASE,
                BASE: BASE,
                open: ['public'],
                files: {
                    html: 'mdi-language-html5',
                    js: 'mdi-nodejs',
                    json: 'mdi-json',
                    md: 'mdi-markdown',
                    pdf: 'mdi-file-pdf',
                    png: 'mdi-file-image',
                    txt: 'mdi-file-document-outline',
                    xls: 'mdi-file-excel'
                },
                tree: [],
                showMenuFolder: false,
                showMenuFile: false,
                x: 0,
                y: 0,
                folder_id: null,
                document: null,
                dialog_create: false,
                dialog_rename: false,
                dialog_upload: false,
                folder_name: '',
                snackbar: false,
                text: 'Hello, I\'m a snackbar',
                download_token: null
            }
        },
        components: {
            vueDropzone: vue2Dropzone
        },
        created () {
            this.checkUser();
            this.getDocuments();
        },
        methods: {
            checkUser() {
                this.$store.dispatch('checkAccessToken').then((res) => {
                    this.download_token = this.$store.getters.getUser.download_token;
                }).catch((error) => {

                });
            },
            getDocuments () {
                this.$store.dispatch('getDirectoriesFtn', {
                    order_id: this.order_id
                }).then((res) => {
                    this.documents = res.data.data;
                    this.dialog_rename = false;
                    this.dialog_create = false;
                    this.dialog_upload = false;
                    this.showMenuFolder = false;
                    this.showMenuFile = false;
                }).catch((error) => {

                });
            },
            show (e, folder_id) {
                e.preventDefault()
                this.showMenuFolder = false
                this.x = e.clientX
                this.y = e.clientY
                this.$nextTick(() => {
                    this.showMenuFolder = true;
                    this.folder_id = folder_id;
                    this.folder_name = '';
                    this.dropzoneOptions.url = API_BASE + 'samples/' + this.order_id + '/folder/' + this.folder_id + '/document';
                })
            },
            showFile (e, folder_id, document) {
                e.preventDefault()
                this.showMenuFile = false
                this.x = e.clientX
                this.y = e.clientY
                this.$nextTick(() => {
                    this.showMenuFile = true;
                    this.folder_id = folder_id;
                    this.folder_name = '';
                    this.document = document;
                })
            },
            createFolder () {
                this.$store.dispatch('createSampleFolder', {
                    order_id: this.order_id,
                    folder_id: this.folder_id,
                    folder_name: this.folder_name
                }).then((res) => {
                    this.getDocuments();
                }).catch((error) => {

                });
            },
            renameFolder () {
                this.$store.dispatch('renameSampleFolder', {
                    order_id: this.order_id,
                    folder_id: this.folder_id,
                    folder_name: this.folder_name
                }).then((res) => {
                    this.getDocuments();
                }).catch((error) => {

                });
            },
            deleteFile () {
                this.$store.dispatch('deleteSampleFolder', {
                    order_id: this.order_id,
                    folder_id: this.folder_id
                }).then((res) => {
                    this.getDocuments();
                }).catch((error) => {
                    this.text = error.data.mensaje;
                    this.snackbar = true;
                });
            }
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/agent/samples/views/DocumentComponent.vue